import { ThemeProvider } from '@mui/material';
import { theme } from './themes';
import './assets/css/main.scss';
import { RouterProvider } from 'react-router-dom';
import { Router } from './routes';
import { AuthProvider } from './hooks/useAuth.hook';
import { WalletProvider } from './hooks/useWallet.hook';

export default function App() {
  const { router } = Router();
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <WalletProvider>
          <RouterProvider router={router} />
        </WalletProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
